import React, { FC } from 'react';
import { Intl } from '@erecruit/core';
import { currencySymbol } from '../helpers';
import { BillingRateDescriptionProps } from '../types';

const BillingRateDescription: FC<BillingRateDescriptionProps> = props => {
  const { rateData, intl } = props;
  const { minimumBillRate, maximumBillRate } = rateData;
  const minimumText =
    `${minimumBillRate} ${currencySymbol(intl)} ` +
    intl.formatMessage({
      id: messageIds.vms.newPositionWizard.billing.minimumBillRateDescription,
    });

  const maximumText =
    `${maximumBillRate} ${currencySymbol(intl)}` +
    intl.formatMessage({
      id: messageIds.vms.newPositionWizard.billing.maximumBillRateDescription,
    });

  if (!minimumBillRate && !maximumBillRate) {
    return null;
  }

  if (minimumBillRate && !maximumBillRate) {
    return <p>{minimumText}</p>;
  }

  if (!minimumBillRate && maximumBillRate) {
    return <p>{maximumText}</p>;
  }

  return (
    <p>
      {minimumBillRate} {currencySymbol(intl)} - {maximumBillRate}{' '}
      {currencySymbol(intl)}
    </p>
  );
};

export default Intl.injectIntl(BillingRateDescription);
